export const CUSTOMERS_QUERY_SEARCH_PARAM_KEY = 'customerQuery';
